import {Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {SelectionBoxSearchComponent} from "../selection.box.search/selection.box.search.component";


@Component({
	selector: 'cp-sb-bar',
	templateUrl: './selection.box.bar.html',
	styleUrls: ['./selection.box.bar.scss'],
	//directives: [SelectionBoxSearchComponent],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class SelectionBoxBarComponent{

	@Input() title:string;
	@Input() searchable:boolean;
	@Input() focus: boolean;
	@Input() diagramPath:string;
	@Input() displayDiagram: boolean;
	@Input() disabled: boolean;
	@Input() placeholderTranslationKey: string;

	@Output() searchItems: EventEmitter<string> = new EventEmitter<string>();
	@Output() diagramIconClick: EventEmitter<Object> = new EventEmitter<Object>();

	@ViewChild(SelectionBoxSearchComponent,{static:false}) searchBox:SelectionBoxSearchComponent;

	public onSearch(str:string){
		this.searchItems.emit(str);
	}

	public clearSearch(){
		this.searchBox.clear();
	}

	public onDiagramIconClick(){
		this.diagramIconClick.emit({});
	}
}
